export interface AppVersion {
  version: string;
  releaseDate?: string;
  changes: string[];
}

export const APP_VERSIONS: AppVersion[] = [
  {
    version: '2.24',
    releaseDate: '2025-12-01',
    changes: [
      'Versión inicial registrada del sistema SynerLab.',
    ],
  },
  {
    version: '3.0',
    releaseDate: '2026-04-26',
    changes: [
      '**Módulo de Control de Calidad**: nuevo módulo para creación de materiales, lotes y controles por niveles, registro de resultados, gráficos Levey-Jennings, reglas de Westgard y Six Sigma básico.',
      '**Impresión y envío masivo de resultados**: nuevo módulo para imprimir y enviar resultados de varias órdenes a la vez.',
      '**Resultados — columna Estado**: se corrige la presentación de las fechas que en algunos casos no se mostraban.',
      '**Envío masivo de resultados por correo y WhatsApp**: ahora pueden enviarse de forma automática y manual.',
      '**Envío de resultados a laboratorios de referencia**: se habilita el envío automático de resultados a laboratorios externos que también usan SynerLab a través del módulo de remisiones externas.',
      '**Muestras y tubos en órdenes**: se incorpora la visualización de muestras y tubos en las pestañas Estudios y Resultados del módulo de órdenes.',
      '**Muestras y tubos en preórdenes**: se incorpora la visualización de muestras y tubos también en preórdenes.',
      '**Búsqueda de órdenes más rápida**: se mejora el rendimiento al filtrar órdenes y se corrige el filtrado por estado desde los botones de resultados.',
      '**Inicio de sesión más seguro**: se incorpora reCAPTCHA durante la autenticación.',
      '**Nuevos filtros en preórdenes**: ahora puede filtrarse por contrato, facturado y RIPS.',
      '**Columna Contrato en preórdenes**: se agrega para identificar fácilmente el contrato asociado a cada preorden.',
      '**Resultados de imágenes DICOM**: se habilita un nuevo tipo de resultado (ImágenesDX) para almacenar y visualizar imágenes en formato DICOM, principalmente de rayos X.',
      '**Trazabilidad de envíos masivos**: nuevo módulo para visualizar el detalle de los resultados enviados masivamente por correo, WhatsApp y remisiones externas.',
      '**Tableros de analizadores y servicios**: se rediseñan los componentes para una visualización más compacta y agradable.',
      '**Tracking**: se corrige la visualización del responsable de cada paso del seguimiento y se agregan permisos por perfil para controlar qué usuarios pueden ejecutar cada paso.',
      '**Remisiones**: ahora se controla si un estudio ya fue remisionado antes de permitir una nueva remisión.',
      '**Acerca de SynerLab**: nuevo módulo para consultar las versiones de SynerLab y los cambios de cada despliegue.',
    ],
  },
];
